import { AbstractControl, ValidationErrors } from "@angular/forms";

export const arrayMinLength = (minLength: number = 1) => {
    return (control: AbstractControl): ValidationErrors | null => {
        return control.value.length < minLength
            ? { arrayMinLength: minLength }
            : null;
    };
};
